import React from "react";
import PlatformDashboard from "./PlatformDashboard";
import PlatformAdminWorkspace from "./PlatformAdminWorkspace";
import PaAccessDenied from "pages/PlatformAdmin/layout/PaAccessDenied";
import { usePlatformDashboardCapabilities } from "pages/PlatformAdmin/hooks/usePlatformPermissions";
import { hasAnyPlatformAdminAccess } from "./platformDashboardCapabilities.utils";

/**
 * Role-aware landing: full dashboard when permitted, otherwise workspace shortcuts.
 */
const PlatformAdminHome = () => {
  const capabilities = usePlatformDashboardCapabilities();

  if (capabilities.canViewDashboard) {
    return <PlatformDashboard />;
  }

  if (hasAnyPlatformAdminAccess()) {
    return <PlatformAdminWorkspace />;
  }

  return (
    <PaAccessDenied
      title="Platform admin"
      subtitle="No assigned permissions"
      description="Contact a Platform Owner to assign a platform role."
    />
  );
};

export default PlatformAdminHome;
